import { atom } from 'jotai'

export const isDisabledAtom = atom(false)
